import { render, staticRenderFns } from "./question-modal.vue?vue&type=template&id=3a594082&scoped=true&"
import script from "./question-modal.vue?vue&type=script&lang=ts&"
export * from "./question-modal.vue?vue&type=script&lang=ts&"
import style0 from "./question-modal.vue?vue&type=style&index=0&id=3a594082&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a594082",
  null
  
)

export default component.exports